<template>
  <div>
    <div v-if="searchable" class="block-search">
      <input class="form__text_lg txt-search" type="text" placeholder="ค้นหา" v-model="search" @keyup="onKeyUp" />
    </div>
    <ul v-if="loaded && items.length > 0"  class="result-item">
      <li class="result-list" v-for="(item, i) in items" :class="{official: isOfficial(item)}">
        <div class="hexagon">
          <span class="num">{{ i + 1 }}</span>
        </div>
        <div class="result-detail">
          <span class="title" v-if="link"><router-link :to="getLink(item)">{{ getTitle(item) }}</router-link></span>
          <span class="title" v-else>{{ getTitle(item) }}</span>
          <span class="amount">{{ getTotal(item) | comma }}</span>
        </div>
      </li>
    </ul>
    <loader v-if="loading" />
    <div class="w-50 ma-auto mt-15 mb-15" v-if="loaded && error && !loading">
      <p class="text-center">ไม่พบข้อมูล</p>
      <a href="#" class="btn btn--white" @click.prevent="refresh">โหลดใหม่อีกครั้ง</a>
    </div>
    <div class="w-50 ma-auto mt-15 mb-15">
      <a class="btn btn--white" href="#" @click.prevent="loadMore" v-if="showLoadMore && items.length > 0">{{ loadMoreButtonText }}</a>
    </div>
  </div>

</template>

<script>
  import Loader from '@/components/Loader'

  export default {
    name: 'ProductLeaderboard',

    components: {
      Loader
    },

    props: {
      loadOnStart: {
        type: Boolean,
        default: true
      },
      titleField: {
        type: String,
        default: 'title'
      },
      type: {
        type: String,
        default: 'pages'
      },
      ipp: {
        type: Number,
        default: 10
      },
      params: {
        type: Object,
        default: () => {
          return {}
        }
      },
      loadMoreButtonText: {
        type: String,
        default: 'ดูเพิ่ม'
      },
      link: {
        type: Boolean,
        default: false
      },
      searchable: {
        type: Boolean,
        default: false
      }
    },

    data () {
      return {
        search: '',
        loaded: false,
        loading: false,
        items: [],
        initialized: false,
        showLoadMore: false,
        error: false
      }
    },

    created () {
      this.reset()

      if (this.loadOnStart) {
        this.init()
      }
    },

    methods: {
      init () {
        if (!this.initialized) {
          this.initialized = true
          this.reset()
          this.fetch(this.params, true)
        }
      },

      reset () {
        this.params.data_order_by = JSON.stringify({ total_product_price: 'DESC,FLOAT' })
        this.params.ipp = this.ipp
        this.params.offset = 0
      },

      refresh () {
        this.reset()
        this.loading = true
        this.loaded = false
        this.items = []
        setTimeout(() => {
          this.fetch(this.params, true)
        }, 1000)
      },

      fetch (params, clearItems) {
        this.loading = true
        this.error = false

        this.$http.get(this.type, {
          params: params,
          before (request) {
            if (this.previousRequest) {
              this.previousRequest.abort()
            }
            this.previousRequest = request
          }
        })
        .then(resp => {
          this.loaded = true
          this.loading = false

          if (clearItems) {
            this.items = []
          }

          const items = resp.body[this.type] || []
          items.forEach(item => {
            try {
              item.data = JSON.parse(item.data)
            } catch (err) {
              item.data = {}
            }
            if (!item.data.total_product_price) {
              item.data.total_product_price = 0
            }
            if (!item.data.total_product_quantity) {
              item.data.total_product_quantity = 0
            }
            this.items.push(item)
          })

          this.pager = resp.body.pager
          const numItems = this.params.offset + this.params.ipp
          const total = this.pager.total || 0
          this.showLoadMore = numItems < total
        })
        .catch(err => {
          console.log(err)
          this.loaded = true
          this.loading = false
          this.error = true
        })
      },

      onKeyUp () {
        if (this.search === this.previousSearch) {
          return
        }
        this.previousSearch = this.search

        this.items = []
        this.loading = true

        if (this.keyTimer) {
          clearTimeout(this.keyTimer)
          this.keyTimer = null
        }
        this.keyTimer = setTimeout(() => {
          this.params.keyword = this.search
          this.params.offset = 0
          this.fetch(this.params, true)
        }, 300)
      },

      loadMore () {
        this.params.offset += this.params.ipp
        this.showLoadMore = false
        this.loading = true
        setTimeout(() => {
          this.fetch(this.params)
        }, 300)
      },

      getLink (item) {
        return `/pages/${item.id}`
      },

      getTotal (item) {
        return item.data.total_product_price
      },

      getTitle (item) {
        return item[this.titleField]
      },

      isOfficial (item) {
        return item.data.official && !item.data.official_school && !item.data.official_province
      }
    }
  }
</script>

<style lang="scss" scoped>
.block-search {
  margin: 3% 3% 0;
  .txt-search { width: 100%; }
}

.result-item {
  overflow: hidden;
  list-style: none;
  padding: 0;
  margin: 0;
  > .result-list {
    border: 1px solid #CFCFCF;
    padding: 15px;
    margin: 15px;
    margin-bottom: 0;
    word-wrap: break-word;
    overflow: hidden;
    border-radius: 5px;
    &.official {
      position: relative;
      &:after {
        position: absolute;
        content: "";
        top: 10px;
        right: 10px;
        background: url("/static/img/logo-domain.png") no-repeat top right;
        background-size: 100%;
        width: 60px;
        height: 40px;
      }
      .result-detail {
        display: block;
        padding-left: 60px;
        .title, .amount {
          display: block;
        }
         .amount {
           padding-left: 0;
           margin-top: 10px;
         }
      }
    }
  }

  .result-detail {
    padding-left: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    align-content: center;
    min-height: 40px;
  }

  .title {
    // float: left;
    font-size: 1.2em;
    line-height: 1.2em;
    color: #F6931D;
    a { color: #F6931D; }
  }
  .amount {
    // float: right;
    padding-left: 5px;
    &:before {
      content: "";
      width: 22px;
      height: 22px;
      padding-left: 30px;
      background: url("../assets/img/icon/ic-amount.png") no-repeat left center;;
      background-size: 22px;
    }
  }
}

@media (max-width: 768px) {
  .result-item {
    > .result-list {
      padding: 10px;
      margin: 10px;
    }

    .result-detail {
      min-height: 40px;
    }

    .title { font-size: 1.1em; }
  }
}
</style>



// WEBPACK FOOTER //
// ProductLeaderboard.vue?72b1c0f7